import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import ApplicationReceiptConfirmation from "../../../../../components/admissions/applicationReceiptConfirmation/applicationReceiptConfirmation";
export const getAdmissionsBasePath = () => `${getAdminBasePath()}/admissions`;
export const getAdmissionsApplicationReceiptConfirmationPath = () => `${getAdmissionsBasePath()}/applicationReceiptConfirmation`;
export const getAdmissionsBaseRoute = () => `${getAdminBaseRoute()}/admissions`;
export const getAdmissionsApplicationReceiptConfirmationRoute = () => `${getAdmissionsBaseRoute()}/applicationReceiptConfirmation`;
const AdminAdmissionsRoutes = () => {
    return (_jsx(Switch, { children: _jsx(Route, { component: ApplicationReceiptConfirmation, path: getAdmissionsApplicationReceiptConfirmationRoute() }) }));
};
export default AdminAdmissionsRoutes;
